
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class BatchRefInput extends Vue {
  @Model("input", { type: String }) readonly value!: string;
  @Prop({ type: String, default: "Batch Reference" }) readonly label!: string;
  @Prop({ type: Boolean, default: true }) readonly isRequired!: boolean;
  @Prop({ type: String, default: "Batch Reference" }) readonly dialogTitle!: string;
  @Prop({ type: String, default: "" }) readonly displayLabel!: string;
  @Prop({ type: String, default: "outlined" }) readonly actionVariant!: "text" | "outlined";
  @Prop({ type: String, default: "primary" }) readonly saveColor!: string;
  @Prop({ type: [String, Number], default: 480 }) readonly maxWidth!: string | number;
  @Prop({ type: Boolean, default: false }) readonly isLocked!: boolean;

  dialog: boolean = false;
  draft: string = "";

  openDialog() {
    if (this.isLocked) {
      return;
    }

    this.draft = this.value || "";
    this.dialog = true;
    this.$nextTick(() => requestAnimationFrame(() => (this.$refs.batchRefInput as any)?.focus() ?? console.error("no ref")));
  }

  closeDialog() {
    this.dialog = false;
  }

  @Watch("dialog")
  onDialogChanged(nextValue: boolean, previousValue: boolean) {
    if (previousValue && !nextValue) {
      this.$nextTick(() => requestAnimationFrame(() => (document.activeElement as HTMLElement | null)?.blur()));
    }
  }

  save() {
    this.$emit("input", this.draft);
    this.closeDialog();
  }
}
